export default __webpack_public_path__ + "static/media/documents.a4208855.png";